export * from "./style.component";
export * from "./stroke.component";
export * from "./fill.component";
export * from "./circle.component";
export * from "./icon.component";
export * from "./text.component";